/* eslint-disable @typescript-eslint/naming-convention */
import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { Payload, ScrollResult } from '../types';
import { EVENTS, isAllowedPlatformParams } from '../constants';
import { mapTagsParams } from './mapTagsParams';

export const mapScroll = (triggerName: ANALYTICS_TRIGGERS, payload: Payload): ScrollResult => {
    const percent_scrolled = triggerName.split('_')[1];
    return {
        ...(isAllowedPlatformParams ? { ...mapTagsParams(payload) } : {}),
        language: payload.language,
        session_id: payload.payload.sessionId,
        is_authenticated: payload.userId ? 1 : 0,
        event: EVENTS.SCROLL,
        event_trigger: triggerName,
        percent_scrolled,
    };
};
